import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@material-ui/core'
import { Modal } from '../../common/Modal'

export const EditAccessLevelModal = ({
    setModalOpen,
    okMethod,
    accessLevel,
}) => {
    const [formState, setFormState] = useState({
        serviceAccessLevelId: accessLevel.serviceAccessLevelId,
        processEngineAccessLevelId: accessLevel.processEngineAccessLevelId,
        title: accessLevel.name,
        isEnabled: accessLevel.isEnabled,
    })

    const formStateSet = () => {
        return !Object.keys(formState).every(
            key => formState[key] !== null && formState[key] !== ''
        )
    }

    const createForm = () => {
        return (
            <Grid>
                <FormControl>
                    <TextField
                        required={true}
                        label={'Title'}
                        value={formState.title}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                title: val,
                            })
                        }}
                    />
                </FormControl>

                <FormControl>
                    <InputLabel required={true}>Is Enabled?</InputLabel>
                    <Select
                        value={formState.isEnabled}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                isEnabled: val,
                            })
                        }}>
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        )
    }

    return (
        <Modal
            data-testid='edit-accesslevel-modal'
            title='Edit Access Level'
            cancelText='Close'
            okText='Save'
            okMethod={() => okMethod(formState)}
            openModal={setModalOpen}
            isOkDisabled={formStateSet()}
            maxWidth='md'
            fullWidth={true}>
            {createForm()}
        </Modal>
    )
}
